import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { key: 0 }

import { ref } from "vue"
import TagView from "@/modules/tag/components/Tag.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Item',
  props: ['item'],
  emits: ['edit', 'select'],
  setup(__props, { emit }) {

const props = __props;

const isHovering = ref(false)




const openLink = () => {
  window.open(props.item.url);

}



return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item = _resolveComponent("q-item")!
  const _directive_ripple = _resolveDirective("ripple")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
    clickable: "",
    class: "row",
    onClick: openLink,
    onMouseover: _cache[2] || (_cache[2] = ($event: any) => (isHovering.value = true)),
    onMouseout: _cache[3] || (_cache[3] = ($event: any) => (isHovering.value = false))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, { class: "col-3 text-left" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_label, { class: "text-no-wrap text-bold ellipsis" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.item.title), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_label, {
            caption: "",
            lines: "2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(props.item.description), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_item_section, { class: "col-8 inline col-grow" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.tags, (tag) => {
              return (_openBlock(), _createBlock(TagView, {
                key: tag.id,
                tag: tag,
                onClick: _withModifiers(($event: any) => (emit('select', tag)), ["stop"])
              }, null, 8, ["tag", "onClick"]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_item_section, { class: "col-1 inline col-shrink" }, {
        default: _withCtx(() => [
          (isHovering.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_q_btn, {
                  onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHovering.value = true)),
                  round: "",
                  color: "green-5",
                  icon: "edit",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('edit', props.item)), ["stop"]))
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  })), [
    [_directive_ripple]
  ])
}
}

})